import { createContext, useContext, useEffect, useState } from "react";
import { useSite } from "@/context/SiteContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { config } = useSite();
  const loc = config?.locations || {};
  const minOrder = Number(loc.min_order || 0);
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("jollanda_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("jollanda_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (dish) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === dish.id);
      if (found) {
        return prev.map((i) => (i.id === dish.id ? { ...i, qty: i.qty + 1 } : i));
      }
      return [...prev, { id: dish.id, name: dish.name, price: dish.price, img: dish.img, cuisine: dish.cuisine, qty: 1 }];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  const updateQty = (id, qty) => {
    if (qty <= 0) return removeItem(id);
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
  };

  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const freeOver = Number(loc.free_delivery_over || 0);
  const deliveryFee = !items.length || (freeOver && subtotal >= freeOver) ? 0 : Number(loc.default_delivery_fee ?? 2.99);
  const serviceFee = Math.round(subtotal * Number(config?.pricing?.service_fee_percent || 0)) / 100;
  const total = subtotal + deliveryFee + serviceFee;

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, count, subtotal, deliveryFee, serviceFee, total, minOrder, freeOver }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}

export const euro = (n) => `€${n.toFixed(2)}`;
